module.exports = __webpack_public_path__ + "img/Historia.a637ee47.png";